import { render, staticRenderFns } from "./AStaffDetailMaintainance.vue?vue&type=template&id=3b8280e9&scoped=true"
import script from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
export * from "./AStaffDetailMaintainance.vue?vue&type=script&lang=js"
import style0 from "./AStaffDetailMaintainance.vue?vue&type=style&index=0&id=3b8280e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b8280e9",
  null
  
)

export default component.exports